<template>
	<div class="wp" :class="{'wp-checkout': mode == 'checkout'}" :id="'product_details_'+data.shopping_cart_code">
		<BaseWebshopRemoveProduct :item="data" v-slot="{onRemove, loading}">
			<figure class="wp-image">
				<NuxtLink :to="data.item.url_without_domain">
					<BaseUiImage v-if="mode == 'checkout'" loading="lazy" :data="data.item?.image_thumbs?.['width120-height120']" default="/images/no-image-120.jpg" :alt="data.item.title" />
					<BaseUiImage v-else loading="lazy" :data="data.item?.image_thumbs?.['width145-height145']" default="/images/no-image-145.jpg" :alt="data.item.title" />
				</NuxtLink>
				<div v-if="mode != 'checkout'" class="wp-btn-delete-mobile" :class="{'loading': loading}" @click="onRemove"><BaseCmsLabel code="remove_product" tag="span" /></div>
			</figure>

			<div class="wp-cnt">
				<div class="wp-inner-cnt">
					<h2 class="wp-title">
						<NuxtLink :to="data.item.url_without_domain">{{ data.item.title }}</NuxtLink>
					</h2>
					<div class="wp-code"><BaseCmsLabel code="code" />: {{data.item.code}}</div>

					<div class="wp-total-mobile" v-if="mode == 'checkout'">
						<div :class="['product_total', (data.total_basic > data.total ? 'wp-price-discount' : 'wp-price-current')]"><BaseUtilsFormatCurrency :price="data.total" /></div>
						<div class="wp-qty-count" v-if="data.quantity > 1">
							<span class="product_qty">{{ data.quantity }}</span> x <BaseUtilsFormatCurrency :price="data.unit_price" />
						</div>
					</div>

					<template v-if="data.item.coupon_price">
						<BaseCmsLabel code="coupon_value" />: <BaseUtilsFormatCurrency :price="data.item.coupon_price" />
					</template>
					<template v-else-if="data.item.bonus_total">
						<BaseCmsLabel code="bonus_total_value" />: <BaseUtilsFormatCurrency :price="data.item.bonus_total" />
					</template>
					<template v-else-if="data.item.type && data.item.type == 'download' && mode != 'checkout'">
						<BaseCmsLabel code="download_files" />
					</template>
				</div>
				
				<template v-if="mode != 'checkout'">
					<BaseWebshopQty :quantity="data.quantity" :item="data" mode="cart" v-slot="{loading, status, onDecrement, onIncrement, onUpdate, onReset, quantity}">
						<div class="wp-qty-cnt wp-qty-cnt-mobile" :class="{'loading': loading}">
							<div class="wp-qty">
								<div class="wp-btn-qty wp-btn-dec" @click="onDecrement">-</div>
								<input class="wp-input-qty product_qty_input" type="text" :value="quantity" @keyup="onUpdate" @blur="onReset" />
								<div class="wp-btn-qty wp-btn-inc" @click="onIncrement">+</div>
								<div class="wp-unit" v-if="data?.unit">{{data.unit}}</div>
								<div class="wp-unit" v-else><BaseCmsLabel code="unit" /></div>
								<span v-show="status" class="wp-message product_message" :class="[{'product_message_response_error': status?.data?.label_name == 'error_limitqty' || status == 'error_product_maximum_qty'}, 'product_message_' + data.shopping_cart_code]"><BaseCmsLabel :code="status" />{{status == 'error_product_maximum_qty' ? ` ${quantity} kom` : ''}}</span>
							</div>
						</div>
					</BaseWebshopQty>
				</template>

				<div class="wp-total wp-total-mobile">
					<div :class="['product_total', (data.total_basic > data.total ? 'wp-price-discount' : 'wp-price-current')]"><BaseUtilsFormatCurrency :price="data.total" /></div>
					<div class="wp-qty-count" v-if="data.quantity > 1">
						<span class="product_qty">{{ data.quantity }}</span> x <BaseUtilsFormatCurrency :price="data.unit_price" />
					</div>
					<span class="wp-extra-lowest-price" v-if="data.extra_price_lowest && data.discount_percentage > 0 && data.extra_price_lowest > 0">
						<BaseCmsLabel code="extra_price_lowest" tag="span" />: <strong><BaseUtilsFormatCurrency :price="data.extra_price_lowest" /></strong>
					</span>
				</div>

				<div v-if="mode != 'checkout'" class="wp-btn-delete" :class="{'loading': loading}" @click="onRemove"><BaseCmsLabel code="remove_product" tag="span" /></div>
			</div>

		</BaseWebshopRemoveProduct>

		<template v-if="mode != 'checkout'">
			<BaseWebshopQty :quantity="data.quantity" :item="data" mode="cart" v-slot="{loading, status, onDecrement, onIncrement, onUpdate, onReset, quantity}">
				<div class="wp-qty-cnt" :class="{'loading': loading}">
					<div class="wp-qty">
						<div class="wp-btn-qty wp-btn-dec" @click="onDecrement">-</div>
						<input class="wp-input-qty product_qty_input" type="text" :value="quantity" @keyup="onUpdate" @blur="onReset" />
						<div class="wp-btn-qty wp-btn-inc" @click="onIncrement">+</div>
						<div class="wp-unit" v-if="data?.unit">{{data.unit}}</div>
						<div class="wp-unit" v-else><BaseCmsLabel code="unit" /></div>
						<span v-show="status" class="wp-message product_message" :class="[{'product_message_response_error': status?.data?.label_name == 'error_limitqty' || status == 'error_product_maximum_qty'}, 'product_message_' + data.shopping_cart_code]"><BaseCmsLabel :code="status" />{{status == 'error_product_maximum_qty' ? ` ${quantity} kom` : ''}}</span>
					</div>
				</div>
			</BaseWebshopQty>
		</template>

		<div class="wp-total">
			<div :class="['product_total', (data.total_basic > data.total ? 'wp-price-discount' : 'wp-price-current')]"><BaseUtilsFormatCurrency :price="data.total" /></div>
			<div class="wp-qty-count" v-if="data.quantity > 1">
				<span class="product_qty">{{ data.quantity }}</span> x <BaseUtilsFormatCurrency :price="data.unit_price" />
			</div>
			<span class="wp-extra-lowest-price" v-if="data.extra_price_lowest && data.discount_percentage > 0 && data.extra_price_lowest > 0">
				<BaseCmsLabel code="extra_price_lowest" tag="span" />: <strong><BaseUtilsFormatCurrency :price="data.extra_price_lowest" /></strong>
			</span>
		</div>
	</div>
</template>

<script setup>
	const props = defineProps(['data', 'mode']);
/* 	const {appendTo, onMediaQuery} = useDom();
	onMediaQuery({
		query: '(max-width: 760px)',
		enter: () => {
			appendTo('.wp-qty-cnt', '.wp-cnt');
			appendTo('.wp-total', '.wp-cnt');
		}
	}); */
</script>

<style lang="less" scoped>
	.wp{display: flex; padding: 22px 0; border-bottom: 1px solid var(--borderColor); margin-top: -1px;}
	.wp-image{
		flex-shrink: 0; display: flex; align-items: center; height: 150px; width: 175px; justify-content: center; padding: 2px;
		:deep(img){display: block; max-height: 100%; max-width: 100%; width: auto; height: auto; margin: auto;}
	}
	.wp-cnt{padding: 2px 25px; width: auto; flex-grow: 1; display: flex; justify-content: space-between; flex-flow: column;}
	.wp-inner-cnt{padding-bottom: 15px;}
	.wp-title{
		font-size: 20px !important; line-height: 26px; padding-top: 0; padding-bottom: 3px; font-weight: normal; color: var(--textColor);
		:deep(a){color: var(--textColor);}
	}
	.wp-code{color: rgba(43,44,55,0.5); font-size: 14px; line-height: 18px; padding-bottom: 3px;}
	.wp-btn-delete,.wp-btn-delete-mobile{
		padding-left: 22px; color: var(--linkColor); position: relative; font-size: 14px; line-height: 24px; text-transform: capitalize; cursor: pointer; text-decoration: underline;
		&:before{.icon-garbage; position: absolute; font: 18px/18px var(--fonti); color: var(--primaryColor); top: 2px; left: 0; transition: var(--transition);}
	}

	.wp-qty-cnt{text-align: center; position: relative; width: 150px; padding-top: 45px; flex-shrink: 0; border-radius: var(--borderRadius);}
	.wp-qty{
		margin-bottom: 0; width: 130px; min-height: 60px; margin: 0 auto; position: relative; text-align: center; margin: 0 auto;
		input{width: 130px; height: 60px; position: relative; text-align: center; padding: 0 50px; font-size: 20px;}
	}
	.wp-btn-qty{
		position: absolute; display: block; left: 0; text-align: center; top: 0; height: 60px; width: 50px; margin: 0; font-size: 0; cursor: pointer; z-index: 9;
		&:before{.pseudo(14px,2px); left: 50%; margin-left: -7px; background: var(--primaryColor); top: 50%; margin-top: -1px;}
	}
	.wp-btn-inc{
		left: unset; right: 0;
		&:after{.pseudo(2px,14px); background: var(--primaryColor); top: 50%; margin-top: -7px; left: 50%; margin-left: -1px;}
	}
	.wp-unit{display: block; text-align: center; text-transform: uppercase; color: var(--textColor); font-weight: 500; font-size: 12px; line-height: 16px; margin-top: 4px;}
	.wp-total{text-align: right; padding-top: 45px; flex-shrink: 0; min-width: 245px; flex-shrink: 0; display: flex; flex-flow: column; align-items: flex-end;}
	.wp-price-current, .wp-price-discount{font-size: 24px; line-height: 26px; color: var(--textColor); font-weight: 400; padding-top: 20px;}
	.wp-price-discount{padding-top: 0 !important; font-weight: bold; color: var(--primaryColor);}
	.wp-price-old, .wp-qty-count{font-size: 14px; line-height: 20px;  text-align: right; color: var(--textColor); display: block; text-decoration: line-through;}
	.wp-qty-count{text-align: right; text-decoration: none; color: var(--textColor);}
	.wp-extra-lowest-price{font-size: 14px; line-height: 19px; color: #98989F; text-align: right; padding-top: 3px; display: block; max-width: 185px;}
	.wp-btn-delete-mobile, .wp-qty-cnt-mobile, .wp-total-mobile{display: none;}
	.wp-message{
		font-size: 11px; margin-top: 5px; line-height: 13px; color: #35CE8D; background: white; z-index: 2; position: absolute; left: 0; width: 100%; bottom: -30px; 
		span.m{display: none!important;}
		@media (max-width: 760px){
			width: calc(~"100% - -20px"); margin-left: -10px; font-size: 10px; padding: 0!important;
			span.d{display: none!important;}
			span.m{display: inline!important;}
		}
	}
	.product_message_response_error{color: var(--red);}

	@media (max-width: @l){
		.wp{padding: 20px 0;}
		.wp-total{min-width: 225px;}
		.wp-price-current, .wp-price-discount{font-size: 22px; line-height: 26px;}
	}
	@media (max-width: @t){
		.wp{padding: 18px 0;}
		.wp-image{height: 105px; width: 95px;}
		.wp-title{font-size: 16px !important; line-height: 20px; padding-bottom: 2px;}
		.wp-code{font-size: 12px; line-height: 16px;}
		.wp-btn-delete{
			padding-left: 19px; font-size: 12px; line-height: 22px;
			&:before{font: 16px/16px var(--fonti); top: 2px; }
		}
		.wp-qty-cnt{width: 130px; padding-top: 27px;}
		.wp-qty{
			width: 115px; min-height: 50px; 
			input{width: 115px; height: 50px; padding: 0 40px; font-size: 18px;}
		}
		.wp-btn-qty{height: 50px; width: 40px; min-width: 40px; min-height: 50px;}
		.wp-unit{font-size: 11px; line-height: 14px; margin-top: 3px;}
		.wp-total{min-width: 170px; padding-top: 25px;}
		.wp-price-current, .wp-price-discount{font-size: 16px; line-height: 20px;}
		.wp-price-old, .wp-qty-count{font-size: 12px; line-height: 16px;}
		.wp-qty-count{padding-top: 1px;}
		.wp-extra-lowest-price{font-size: 12px; line-height: 16px; max-width: 160px;}
	}
	@media (max-width: @tp){
		.wp{padding: 15px 0;}
		.wp-cnt{padding: 2px 15px;}
	}
	@media (max-width: @m){
		.wp{padding: 12px 15px; display: flex; flex-wrap: wrap;}
		.wp-image{height: 82px; width: 96px;}
		.wp-cnt{padding: 1px 16px; padding-right: 0; width: calc(~"100% - 96px"); flex-grow: 1;}
		.wp-btn-delete{display: none;}
		.wp-title{line-height: 18px; padding-bottom: 4px;}
		.wp-btn-delete-mobile{
			display: block; width: 75px; display: block; margin-left: 13px; align-self: center; font-size: 12px; line-height: 22px; padding-left: 20px; text-decoration: none; align-self: baseline;
			&:before{font: 15px/15px var(--fonti); top: 3px;}
		}
		.wp-qty-cnt{width: 90px; padding-top: 10px; align-self: baseline; margin-left: 10px;}
		.wp-qty{
			width: 90px; min-height: 44px;
			input{width: 90px; height: 44px; padding: 0 30px; font-size: 16px;}
		}
		.wp-btn-qty{
			height: 44px; width: 30px; min-width: 30px; min-height: 44px;
			&:before{width: 12px; margin-left: -6px;}
		}
		.wp-btn-inc:after{height: 12px; margin-top: -6px;}
		.wp-unit{font-size: 10px; line-height: 13px; margin-top: 3px;}
		.wp-message{background: white; padding: 3px;}
		.wp-total{min-width: auto; padding-top: 8px; flex-grow: 1; display: flex; flex-flow: column; align-items: flex-end;}
		.wp-price-current, .wp-price-discount{font-size: 16px; line-height: 20px; display: flex; flex-flow: column;}
		.wp-price-old, .wp-qty-count{font-size: 10px; line-height: 14px;}
		.wp-extra-lowest-price{width: 115px; max-width: unset; font-size: 10px; line-height: 14px;}

		.wp:not(.wp-checkout){
			 padding-bottom: 2px;
			.wp-image{
				flex-flow: column; height: auto; max-height: 110px; padding: 0; justify-content: unset;
				&>a{height: 82px;}
			}
			.wp-btn-delete-mobile{
				margin: 13px auto 0; width: auto; padding-left: 16px;
				&:before{font-size: 14px; line-height: 14px;}
			}
			.wp-cnt{flex-flow: unset; flex-wrap: wrap; justify-content: unset;}
			.wp-inner-cnt{width: 100%; padding-bottom: 10px;}
			.wp-qty-cnt{flex: 0 0 96px; width: 96px; padding-top: 0; margin-left: 0; display: none;}
			.wp-qty-cnt-mobile{display: block;}
			.wp-qty{
				width: 96px;
				input{width: 96px;}
			}
			.wp-total{width: calc(~"100% - 96px"); flex: unset; padding-top: 0; display: none;}
			.wp-total-mobile{display: flex;}
			.wp-price-current{padding-top: 12px; font-weight: bold;}
		}
	}

	//Checkout
	.wp-checkout{
		padding: 20px 40px 20px 40px; border-top: 1px solid var(--borderColor);
		.wp-image{height: 95px; width: 110px;}
		.wp-cnt{padding: 0 10px 0 15px;}
		.wp-title{font-size: 16px !important; line-height: 22px; padding-bottom: 2px;}
		.wp-old-price,.wp-price-label,.wp-qty-count{font-size: 14px; line-height: 18px;}
		.wp-price-current,.wp-price-discount{font-size: 18px; line-height: 22px; padding-top: 10px;}
		.wp-price-discount{padding-top: 0 !important;}
		.wp-total{min-width: 165px; padding-top: 5px;}
		.wp-extra-lowest-price{max-width: 165px;}
		@media (max-width: @t){
			padding: 15px 30px 15px 30px;
			.wp-title{font-size: 16px !important; line-height: 20px; padding-bottom: 2px;}
			.wp-cnt{padding-left: 10px;}
			.wp-qty-count,.wp-extra-lowest-price{font-size: 11px; line-height: 14px;}
			.wp-total{min-width: 135px; padding-left: 5px; padding-top: 0;}
			.wp-price-current,.wp-price-discount{font-size: 14px; line-height: 18px;}
			.wp-image{width: 100px; height: 85px; padding: 0;}
			.wp-extra-lowest-price{max-width: 120px;}
		}
		@media (max-width: @tp){
			padding: 15px;
			.wp-title{font-size: 14px !important; line-height: 18px; padding-bottom: 2px;}
			.wp-cnt{padding-left: 10px;}
			.wp-total{min-width: 95px; padding-left: 5px; padding-top: 0;}
			.wp-price-current,.wp-price-discount{font-size: 14px; line-height: 18px; padding-top: 0 !important;}
			.wp-image{width: 70px; height: 60px; padding: 0;}
		}
		@media (max-width: @m){
			flex-wrap: unset;
			.wp-cnt{width: auto;}
			.wp-total{padding-left: 0;}
			.wp-qty-count{font-size: 10px; line-height: 14px;}
			.wp-extra-lowest-price{font-size: 10px; line-height: 14px; max-width: 85px;}
		}
	}
</style>
